// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__uXHy5jnqkqgZv","footer":"footer__UF97X8i1n13vJ"};